import React from 'react';

const LegacyUserIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M18.2 20C18.2 18.4087 17.5678 16.8826 16.4426 15.7574C15.3174 14.6321 13.7913 14 12.2 14C10.6087 14 9.08253 14.6321 7.95731 15.7574C6.83209 16.8826 6.19995 18.4087 6.19995 20"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M12.2 14C14.4091 14 16.2 12.2091 16.2 10C16.2 7.79086 14.4091 6 12.2 6C9.99081 6 8.19995 7.79086 8.19995 10C8.19995 12.2091 9.99081 14 12.2 14Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M12.2 22C17.7228 22 22.2 17.5228 22.2 12C22.2 6.47715 17.7228 2 12.2 2C6.6771 2 2.19995 6.47715 2.19995 12C2.19995 17.5228 6.6771 22 12.2 22Z"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default LegacyUserIcon;
